import React from 'react';
export function PricingSection() {
  return <section id="precios" className="py-20 w-full" style={{
    backgroundColor: '#f5f5f5'
  }} aria-labelledby="precios-title" data-id="element-154">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-156">
          <span className="inline-block text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-157">
            Elegí tu Pack
          </span>
          <h2 id="precios-title" className="font-heading text-4xl sm:text-5xl font-bold text-navy-deep mb-4" data-id="element-158">
            Acceso Inmediato a Todo
          </h2>
          <p className="text-gray-500 text-lg" data-id="element-159">
            Acceso inmediato a todos los recursos
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start" data-id="element-160">
          {/* Card 1: Oferta Limitada */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col" style={{
          border: '2px solid #c9a84c'
        }} data-id="element-161">
            {/* Top Badge */}
            <div className="bg-gold text-navy-deep text-center font-bold uppercase tracking-widest text-sm py-3" data-id="element-162">
              OFERTA LIMITADA
            </div>

            <div className="p-8 flex flex-col flex-1" data-id="element-163">
              {/* Product Name */}
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-164">
                Mega Pack Catequesis Lista
              </h3>
              <p className="text-gray-500 text-sm mb-6" data-id="element-165">
                Todo lo que necesitás para dar clases increíbles de catequesis
              </p>

              {/* Price */}
              <div className="mb-6 flex items-center gap-4" data-id="element-166">
                <div data-id="element-167">
                  <p className="text-gray-400 line-through text-sm" data-id="element-168">$47.990</p>
                  <p className="font-heading text-5xl font-bold text-gold leading-none" data-id="element-169">
                    $19.990
                  </p>
                </div>
                <div className="bg-red-500 text-white font-bold text-sm rounded-full w-14 h-14 flex items-center justify-center flex-shrink-0" data-id="element-170">
                  -58%
                </div>
              </div>

              {/* CTA */}
              <a href="https://tfjcep-yg.myshopify.com/cart/43485660938318:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-navy-deep font-bold text-lg py-4 rounded-full hover:bg-gold-light transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-3 text-center" aria-label="Adquirir Mega Pack Catequesis Lista por $19.990" data-id="element-171">
                Sí, quiero esta oferta
              </a>
              <p className="text-gray-400 text-xs text-center mb-6" data-id="element-172">
                Pago seguro con Mercado Pago 🔒
              </p>

              {/* Divider */}
              <div className="border-t border-gray-100 pt-6" data-id="element-173">
                <p className="font-bold text-navy-deep uppercase tracking-wider text-sm mb-4" data-id="element-174">
                  INCLUYE:
                </p>
                <ul className="space-y-3" role="list" data-id="element-175">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-176">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-177">
                      ✅
                    </span>
                    <span data-id="element-178">12 Tomos PDF (Primaria + Secundaria)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-179">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-180">
                      ✅
                    </span>
                    <span data-id="element-181">Tomo 1–6: Primaria completa (1° a 6° grado)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-182">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-183">
                      ✅
                    </span>
                    <span data-id="element-184">Tomo 7–12: Secundaria completa (1° a 6° año)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-185">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-186">
                      ✅
                    </span>
                    <span data-id="element-187">Bono Ruta Anual 36 Semanas</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-188">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-189">
                      ✅
                    </span>
                    <span data-id="element-190">Bono Guía Comunión y Confirmación</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-191">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-192">
                      ✅
                    </span>
                    <span data-id="element-193">Bono Catequesis sin Caos</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-194">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-195">
                      ✅
                    </span>
                    <span data-id="element-196">Acceso y descarga de por vida</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 2: Mejor Valor */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col" style={{
          border: '2px solid #1a2e4a'
        }} data-id="element-197">
            {/* Top Badge */}
            <div className="bg-navy-deep text-gold text-center font-bold uppercase tracking-widest text-sm py-3" data-id="element-198">
              🔥 OFERTA ESPECIAL — PACK COMPLETO
            </div>

            <div className="p-8 flex flex-col flex-1" data-id="element-199">
              {/* Label above */}
              <p className="text-gold text-xs font-bold uppercase tracking-widest mb-2" data-id="element-200">
                MEGA PACK + BONO EXCLUSIVO
              </p>

              {/* Product Name */}
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-201">
                Mega Pack + Adaptación para el Aula Real
              </h3>
              <p className="text-gray-500 text-sm mb-4" data-id="element-202">
                El Mega Pack completo{' '}
                <strong className="text-navy-deep" data-id="element-203">más</strong> el ebook premium{' '}
                <em data-id="element-204">"Pack de Adaptación por Realidades del Aula"</em> — para que
                tus clases funcionen incluso en los contextos más difíciles de
                Argentina.
              </p>

              {/* Problem/Promise callout */}
              <div className="rounded-xl p-4 mb-5 text-sm" style={{
              backgroundColor: 'rgba(201, 168, 76, 0.10)',
              border: '1px solid rgba(201, 168, 76, 0.3)'
            }} data-id="element-205">
                <p className="font-bold text-navy-deep mb-2" data-id="element-206">
                  ¿Tu curso es difícil? Este bono es para vos:
                </p>
                <ul className="space-y-1 text-gray-600" data-id="element-207">
                  <li data-id="element-208">⚡ Cursos heterogéneos o multigrado</li>
                  <li data-id="element-209">⚡ Baja participación o lectoescritura</li>
                  <li data-id="element-210">⚡ Contextos vulnerables</li>
                  <li data-id="element-211">⚡ Semanas cortas por feriados y actos</li>
                </ul>
              </div>

              {/* Price */}
              <div className="mb-6 flex items-center gap-4" data-id="element-212">
                <div data-id="element-213">
                  <p className="text-gray-400 line-through text-sm" data-id="element-214">$69.990</p>
                  <p className="font-heading text-5xl font-bold text-navy-deep leading-none" data-id="element-215">
                    $27.990
                  </p>
                </div>
                <div className="bg-red-500 text-white font-bold text-sm rounded-full w-14 h-14 flex items-center justify-center flex-shrink-0" data-id="element-216">
                  -57%
                </div>
              </div>

              {/* CTA */}
              <a href="https://tfjcep-yg.myshopify.com/cart/43485716578382:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-navy-deep text-white font-bold text-lg py-4 rounded-full hover:bg-navy-dark transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-3 text-center" aria-label="Adquirir Mega Pack + Bono Adaptación por $27.990" data-id="element-217">
                Sí, quiero esta oferta
              </a>
              <p className="text-gray-400 text-xs text-center mb-6" data-id="element-218">
                Pago seguro con Mercado Pago 🔒
              </p>

              {/* Divider */}
              <div className="border-t border-gray-100 pt-6" data-id="element-219">
                <p className="font-bold text-navy-deep uppercase tracking-wider text-sm mb-4" data-id="element-220">
                  TODO EL PACK BÁSICO MÁS:
                </p>
                <ul className="space-y-3" role="list" data-id="element-221">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-222">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-223">
                      ✅
                    </span>
                    <span data-id="element-224">
                      <strong data-id="element-225">Estrategias por escenario</strong> — soluciones
                      concretas para cada realidad del aula argentina
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-226">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-227">
                      ✅
                    </span>
                    <span data-id="element-228">
                      <strong data-id="element-229">Guiones y frases exactas</strong> para manejar
                      situaciones difíciles sin improvisar
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-230">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-231">
                      ✅
                    </span>
                    <span data-id="element-232">
                      <strong data-id="element-233">Estructuras de clase</strong> para 40 y 80 minutos
                      adaptadas al contexto
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-234">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-235">
                      ✅
                    </span>
                    <span data-id="element-236">
                      <strong data-id="element-237">Kits de clase corta</strong> de 10 y 20 min para
                      semanas con feriados o actos
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-238">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-239">
                      ✅
                    </span>
                    <span data-id="element-240">
                      <strong data-id="element-241">Casos completos ya redactados</strong> — copiá,
                      adaptá y usá directamente
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-242">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-243">
                      ✅
                    </span>
                    <span data-id="element-244">
                      100% en PDF — sin links, sin audios, sin conexión a
                      internet
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Below cards */}
        <p className="text-center text-gray-500 text-sm mt-8" data-id="element-245">
          Garantía 7 días &nbsp;•&nbsp; Acceso inmediato
        </p>
      </div>
    </section>;
}